import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Domain } from 'app/models/domain.model';

@Component({
  selector: 'app-select-domain',
  templateUrl: './select-domain.component.html',
  styleUrls: ['./select-domain.component.css']
})
export class SelectDomainComponent implements OnInit {

  domains: Domain[];
  constructor(
    public dialogRef: MatDialogRef<SelectDomainComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    this.domains = this.data.domains;
  }

  domainForm = this.formBuilder.group({
    domain: ['', Validators.required]
  });

  cancel(){
    this.dialogRef.close();
  }

  continueToRoute(){
    console.log('selected domain: ', this.domainForm.value.domain);
    this.dialogRef.close({
      selectedDomain: this.domainForm.value.domain
    });
  }

}
